<template>
	<div class="owl-carousel slider-navigation">
		<div class="item" v-for="item in items">
			<div class="containerItem">
				<div class="top">
					<a :href="item.href_img" class="topBlock" :lazy-background='item.img'></a>
				</div>
				<div class="bottom">
					<a :href="item.href_name" class="ttl" v-if="item.header" v-html="item.header"></a>
					<div class="priceAndBuy">
						<div class="priceContainer">
							<p class="sale" v-if="item.sale" v-html="item.sale"></p>
							<p v-if="item.oldPrice" v-html="item.oldPrice" class="oldPrice"></p>
							<p v-if="item.price" v-html="item.price" class="price"></p>
						</div>
						<a class="buy waves-effect waves-light sale" :href="item.href_button">
							<svg fill="#FFFFFF" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
								<path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
								<path d="M0-.25h24v24H0z" fill="none"/>
							</svg>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['items', 'sliderParams'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 3 ? true : false,
				nav: true,
				dots: true,
				margin: 30,
				responsive: {
					0: {
						items:
							this.sliderParams && this.sliderParams.slide &&
							this.sliderParams.slide.small ? this.sliderParams.slide.small : 1,
					},
					1024: {
						items:
							this.sliderParams && this.sliderParams.slide &&
							this.sliderParams.slide.medium ? this.sliderParams.slide.medium : 2,
					},
					1180: {
						items:
							this.sliderParams && this.sliderParams.slide &&
							this.sliderParams.slide.desktop ? this.sliderParams.slide.desktop : 3,
					}
				}
			}
		});
	},

	mounted() {
		setTimeout( () => {
			lazyBackground();
		}, 1500);
	}
}
</script>

<style lang="scss" >
@import "scss/wanted";
.slider-catalogVuesliderToSections {
	padding-bottom: 72px;
	.owl-carousel {
		padding: 0 2px;
		position: relative;
		padding-bottom: 70px;
		.owl-stage-outer{
		}
		.item {
			padding: 0px 0px;
			background-color: transparent;
			width: 100%;
			padding-right: 2px;
			.wr{
				position: relative;
				background-color: transparent;

				&:after{
					position: absolute;
					top: 0;
					right: 0;
					bottom: 0;
					left: 0;
					z-index: -1;
					content: '';
					border-radius: 5px;
					box-shadow: 0px 3px 5.88px 0.12px rgba(226, 237, 243, 0.5);
				}
			}
			.top{
				border: 1px solid #e2edf3;
				box-shadow: 0px -3px 2px #e2edf3;
				border-bottom: 2px dotted #eaf1f6;
				border-radius: 5px;
				position: relative;
				z-index: 11;
			}
			.topBlock{
				display: block;
				height: 228px;
				background-position: center;
				background-repeat: no-repeat;
				position: relative;
				background-size: auto 165px;
				background-position: center;
			}

			.bottom{
				padding: rem(19) rem(29);
				height: 150px;
				border: 1px solid #e2edf3;
				border-radius: 5px;
				border-top: none;
				border-top-right-radius: 0;
				border-top-left-radius: 0;
				background-color: white;
				border: 1px solid #e2edf3;
				box-shadow: 0px 0px 2px #e2edf3;
				border-radius: 5px;
				position: relative;
				top: -1px;
				z-index: 0;
				padding-bottom: 30px;
				&:after{
					content: "";
					width: 98%;
					position: absolute;
					top: -2px;
					left: 3px;
					right: 0;
					height: 2px;
					background: #fff;
				}
				.ttl{
					font-size: rem(14);
					line-height: rem(27);
					height: rem(54);
					overflow: hidden;
					color: black;
					text-decoration: none;
					margin-bottom: 4px;
					padding: 0;
					font-weight: 900;
					display: block;
					&:hover{
						text-decoration: underline;
					}
				}
				.priceAndBuy{
					display: flex;
					justify-content: space-between;
					.priceContainer{
						.oldPrice{
							font-size: rem(13);
							line-height: rem(20);
							height: rem(20);
							color: #7e8183;
							b{
								font-weight: normal;
								text-decoration: line-through;
							}
							i{
								font-style: normal;
								font-size: rem(11);
							}
						}
						.price{
							color: #000;
							font-weight: 900;
						}
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// catalogVuesliderToSections.vue?eb6c19d4